import {getViewer} from 'api/config/config';

/**
 * @module utils/startup
 */

/**
 * Defines the parameter for setConfigValues function
 */
export interface StartUpConfigValues {
    cloudfrontViewerCountryCode: string | null;
}

/**
 * Loads the viewer details from the API and then sets the response.
 * A failure to load the viewer details is not fatal; the country code is left as `null`.
 *
 * @param setConfigValues - The function to set the configuration values
 * @returns A promise that resolves when the configuration has been set
 */
const loadConfig = async (
    setConfigValues: (configValues: StartUpConfigValues) => void
): Promise<void> => {
    const viewer = await getViewer().catch(() => null);

    setConfigValues({
        cloudfrontViewerCountryCode:
            viewer?.cloudfrontViewerCountryCode ?? null,
    });
};

export default loadConfig;
